/**
 * Placeholder for a list that is still loading.
 *
 * A centred spinner told an admin only that *something* was happening; a shape
 * that matches the table about to arrive keeps the page from jumping.
 */
export const TableSkeleton = ({ rows = 6 }: { rows?: number }) => (
    <div className="card card--flush skeleton-table" aria-busy="true">
        {Array.from({ length: rows }, (_, index) => (
            <div
                className="skeleton-row"
                key={index}
                style={{ width: `${[62, 84, 71, 90, 55, 78, 66, 88][index % 8]}%` }}
            />
        ))}
    </div>
);
